import React from 'react';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';
import { inject, observer } from 'mobx-react';
import ContinueWithTwitchBanner from './ContinueWithTwitchBanner';
import SponsorshipsBanner from './SponsorshipsBanner';
import { get } from 'lodash';

const propTypes = {
    classes: PropTypes.object.isRequired
}

@inject('auth', 'store') @observer
class BannerV2 extends React.Component {
    constructor(props) {
        super(props)
    }

    render() {
        const { classes, store } = this.props;
        const { sponsorships, user, userLoading, sponsorshipsLoading } = store;
        const isLoading = userLoading || sponsorshipsLoading;
        const hasSponsorships = sponsorships && sponsorships.length > 0;
        const shouldShowNewBanner = hasSponsorships && get(user, 'ab.p2s_chatstats_v1', '0') === '1';

        if (isLoading) {
            return null;
        }

        return (
            <div className={classes.root}>
                {!shouldShowNewBanner && <ContinueWithTwitchBanner />}
                {shouldShowNewBanner && <SponsorshipsBanner />}
            </div>
        )
    }
}

const styles = theme => ({ });

BannerV2.propTypes = propTypes;

export default injectSheet(styles)(BannerV2);



// WEBPACK FOOTER //
// ./src/app/components/bannerV2/BannerV2.js